import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const NotFound = () => (
  <>
    <SEO title="404 — Not Found" description="The page you are looking for could not be found." />
    <section className="relative bg-[#0a0a0a] min-h-[80vh] flex items-center justify-center px-6 text-center grain overflow-hidden">
      <div className="relative z-10">
        <p className="tiny-link text-[#FF69B4]">Off the map</p>
        <h1 className="font-display text-7xl sm:text-9xl mt-3 tracking-[0.03em]">
          404<span className="text-[#FF69B4]">.</span>
        </h1>
        <p className="text-white/60 mt-6 max-w-md mx-auto">
          Yeah, you're lost. But we like it. Head back to the drop.
        </p>
        <Link
          to="/collections"
          data-testid="notfound-shop-cta"
          className="pink-cta tiny-link inline-block px-8 py-4 mt-8"
        >
          Back to Shop →
        </Link>
      </div>
    </section>
  </>
);

export default NotFound;
